import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useFetch, usePromise } from '@rad/hooks';
import { Instant } from '@rad/utility/datetime';
import { formatDatetimeLong } from '@rad/utility/formatting';
import { getUser } from '../types';
export const UserTimestamp = (props) => {
    const [userPromise] = useFetch(getUser(props.user_id));
    const user = usePromise(userPromise);
    const formatted = React.useMemo(() => formatDatetimeLong(Instant.parse(props.timestamp)), [props.timestamp]);
    return _jsx(_Fragment, { children: user === undefined ? 'Loading...' : user === null ? `by Unknown on ${formatted}` : `by ${user.firstname} ${user.lastname} on ${formatted}` });
};
export default UserTimestamp;
